import { useState, useEffect } from "react";
import { TextField, Button, IconButton, InputAdornment, Container, Box, Typography } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { setPasswordAction } from '../../services/auth'
import { useNavigate } from "react-router-dom";


const SetPassword = () => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();
  const { phone, token } = location.state || {};
  const navigate = useNavigate();

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handlePasswordChange = async(e) => {
    e.preventDefault();
    console.log("click")
    try {
        await setPasswordAction(phone, token, password)
    } catch (e) {
        console.log('error', e)
    }
  };
useEffect(()=> {
    console.log(phone, token)

    if (!(phone && token)) {
        navigate('/')
    }
}, [phone, token])
  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, p: 3, boxShadow: 3, borderRadius: 2, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Set Password
        </Typography>
          <TextField
            label="New Password"
            type={showPassword ? "text" : "password"}
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleTogglePassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button onClick={handlePasswordChange} variant="contained" fullWidth sx={{ mt: 2 }}>
            Set
          </Button>
      </Box>
    </Container>
  );
};

export default SetPassword;
